<template>
    <v-container
        fluid
        class="sidebar-content general-sidebar"
    >
        <div
            class="sidebar-subtitle pb-2"
            v-if="data.title || data.subtitle"
        >
            <h2 class="sidebar-header__title">
                {{ data.title || data.subtitle }}
                <v-tooltip
                    v-if="!isStandalone" 
                    content-class="bottom" 
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                    <a
                        id="gtm-plotsidebar-cta-favorite"
                        @click.prevent="toggleFavorite()"
                        class="favorite-sidebar"
                        @mouseover="hover = true"
                        @mouseleave="hover = false"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <i
                            v-if="isFavorite"
                            class="icon heart"
                            :class="{
                                'icon-favorite active-heart': isFavorite,
                                'icon-empty-favorite' : !isFavorite
                            }"
                        />
                        <i
                            v-else
                            class="icon heart"
                            :class="{
                                'icon-favorite active-heart': hover,
                                'icon-empty-favorite' : !hover
                            }"
                        />
                    </a>
                    </template>
                    <span>
                        {{ $t('favorite.saveYourFavorite') }}
                    </span>
                </v-tooltip>
            </h2>
        </div>
        <v-list>
            <v-list-item
                v-if="$route.query.key != '5qRvzgfzOHEfe5dYUwGrJY'"
                class="models-nav-item pb-12 share-favorite"
            >
                <v-dialog
                    class="share-favorite-dialog"
                    v-model="shareDialog"
                    width="320px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            id="gtm-plotsidebar-share-plot"
                            class="copy-cta text-none pl-1 habiteo-body-2 font-weight-bold"
                            text
                            x-small
                            :ripple="false"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon left>
                                icon-share
                            </v-icon>
                            {{ $t('share.share') }}
                        </v-btn>
                    </template>

                    <v-card>
                        <v-toolbar flat>
                            <h2 class="pl-3 font-weight-regular">
                                {{ $t('share.share') }}
                            </h2>
                            <v-spacer/>
                            <v-toolbar-items>
                                <v-btn
                                    text
                                    @click="shareDialog = false"
                                >
                                    <v-icon>
                                        mdi-close
                                    </v-icon>
                                </v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text>
                            <div class="d-flex share-favorite-link">
                                <div
                                    id="urlToCopy"
                                    class="pa-2 text-truncate"
                                >
                                    {{ widgetLink }}
                                </div>

                                <v-btn
                                    id="gtm-plotsidebar-cta-copy-plot"
                                    text
                                    class="text-none copy-cta font-weight-bold"
                                    @click="copyLink()"
                                >
                                    {{ $t('share.copyLink') }}
                                </v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-list-item>
            <v-list-item
                v-for="(item, ind) in data.items"
                :key="'item' + ind"
                class="models-nav-item pb-8"
            >
                <template v-if="item.submenu">
                    <v-tooltip
                        v-if="!isOnline && isOfflineMode && !offlineWidgets.includes(item.id)"
                        content-class="right"
                        right
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                v-bind="attrs"
                                v-on="on"
                            >
                                <span class="main-nav-item main-nav-item_start disabled">
                                    <span class="icon-holder">
                                        <div
                                            class="rounded"
                                            :style="{ 'backgroundImage': 'url(' + item.preview + ')' }"
                                            v-if="item.preview"
                                        />
                                        <div
                                            class="rounded"
                                            :style="{ 'backgroundImage': 'url('+ item.icon + ')' }"
                                            v-else-if="item.icon"
                                        />
                                    </span>
                                    <span class="nav-text global-nav pb-2">
                                        {{ item.text }}
                                    </span>
                                </span>
                                <div
                                    class="scrollbar"
                                    v-bar="{
                                        overrideFloatingScrollbar: true,
                                        observerThrottle: 0,
                                        draggingPhantomDelay: 0,
                                        scrollingPhantomDelay: 0,
                                        resizeRefresh: false
                                    }"
                                >
                                    <div
                                        class="scrollable"
                                        ref="scrollable"
                                    >
                                        <v-list class="divider-left sub-menu props-list disabled">
                                            <v-item-list
                                                v-for="(subitem, index) in item.submenu"
                                                class="pl-4"
                                                :class="{ 'pb-2': index < item.submenu.length - 1 }"
                                                :key="'subitem' + index"
                                            >
                                                <a>
                                                    {{ subitem.text }}
                                                </a>
                                            </v-item-list>
                                        </v-list>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <span>
                            {{ $t("pwa.offline.disabledWidget") }}
                        </span>
                    </v-tooltip>
                    <div v-else>
                        <span class="main-nav-item main-nav-item_start">
                            <span class="icon-holder">
                                <div
                                    class="rounded"
                                    :style="{ 'backgroundImage': 'url(' + item.preview + ')' }"
                                    v-if="item.preview"
                                />
                                <div
                                    class="rounded"
                                    :style="{ 'backgroundImage': 'url(' + item.icon + ')' }"
                                    v-else-if="item.icon"
                                />
                            </span>
                            <span class="nav-text global-nav pb-2">
                                {{ item.text }}
                            </span>
                        </span>
                        <div
                            class="scrollbar"
                            v-bar="{
                                overrideFloatingScrollbar: true,
                                observerThrottle: 0,
                                draggingPhantomDelay: 0,
                                scrollingPhantomDelay: 0,
                                resizeRefresh: false
                            }"
                        >
                            <div
                                class="scrollable"
                                ref="scrollable"
                            >
                                <v-list
                                    :id="`gtm-sidebar-cta-${item.id}`"
                                    class="divider-left sub-menu props-list"
                                >
                                    <v-list-item
                                        v-for="(subitem, index) in item.submenu"
                                        :key="`subitem-${index}`"
                                        class="pl-4"
                                        :class="{ 'pb-2': index < item.submenu.length - 1 }"
                                    >
                                        <a
                                            href="#"
                                            :class="{ 'active': !!subitem.active && item.active }"
                                            @click.prevent="setActive(item, subitem)"
                                        >
                                            {{ subitem.text }}
                                        </a>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- External links template -->
                <template v-else-if="item.url">
                    <v-tooltip
                        v-if="!isOnline && isOfflineMode && !offlineWidgets.includes(item.id)"
                        content-class="right"
                        right
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                v-bind="attrs"
                                v-on="on"
                                class="main-nav-item main-nav-item_start pb-2 disabled"
                            >
                                <span class="icon-holder">
                                    <div
                                        class="rounded"
                                        :style="{ 'backgroundImage': 'url(' + item.preview + ')' }"
                                        v-if="item.preview"
                                    />
                                    <div
                                        class="rounded"
                                        :style="{ 'backgroundImage': 'url('+ item.icon + ')' }"
                                        v-else-if="item.icon"
                                    />
                                </span>
                                <span class="nav-text global-nav">
                                    {{ item.text }}
                                </span>
                            </div>
                        </template>
                        <span>
                            {{ $t("pwa.offline.disabledWidget") }}
                        </span>
                    </v-tooltip>
                    <a
                        v-else
                        :id="`gtm-sidebar-cta-${item.id}`"
                        href="#"
                        class="main-nav-item main-nav-item_start"
                        :class="{ 'active': item.active }"
                        @click.prevent="setActive(item)"
                    >
                        <span class="icon-holder">
                            <div
                                class="rounded"
                                :style="{ 'backgroundImage': 'url(' + item.preview + ')' }"
                                v-if="item.preview"
                            />
                            <div
                                class="rounded"
                                :style="{ 'backgroundImage': 'url(' + item.icon + ')' }"
                                v-else-if="item.icon"
                            />
                        </span>
                        <span class="nav-text global-nav">
                            {{ item.text }}
                        </span>
                    </a>
                </template>
                <!-- /External links template -->

                <template v-else>
                    <v-tooltip
                        v-if="!isOnline && isOfflineMode && !offlineWidgets.includes(item.id)"
                        content-class="right"
                        right
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                v-bind="attrs"
                                v-on="on"
                                class="main-nav-item main-nav-item_start disabled"
                            >
                                <span class="icon-holder">
                                    <div
                                        class="rounded"
                                        :style="{ 'backgroundImage': 'url('+ item.preview +')' }"
                                        v-if="item.preview"
                                    />
                                    <div
                                        class="rounded"
                                        :style="{ 'backgroundImage': 'url('+ item.icon +')' }"
                                        v-else-if="item.icon"
                                    />
                                </span>
                                <span class="nav-text global-nav">
                                    {{ item.text }}
                                </span>
                            </div>
                        </template>
                        <span>
                            {{ $t("pwa.offline.disabledWidget") }}
                        </span>
                    </v-tooltip>
                    <a
                        v-else
                        :id="`gtm-sidebar-cta-${item.id}`"
                        href="#"
                        class="main-nav-item main-nav-item_start"
                        :class="{ active: item.active}"
                        @click.prevent="setActive(item)"
                    >
                        <span class="icon-holder">
                            <div
                                class="rounded"
                                :style="{ 'backgroundImage': 'url('+ item.preview +')' }"
                                v-if="item.preview"
                            />
                            <div
                                class="rounded"
                                :style="{ 'backgroundImage': 'url('+ item.icon +')' }"
                                v-else-if="item.icon"
                            />
                        </span>
                        <span class="nav-text global-nav">
                            {{ item.text }}
                            <span
                                v-if="item.id === 'drone-floor-view' && currentLevel"
                                class="subtitle habiteo-body-2 pa-0 grey-text text-lighten-1"
                            >
                                ({{ currentLevel.value }})
                            </span>
                        </span>
                    </a>
                </template>
            </v-list-item>
        </v-list>
        <div
            class="description-box"
            v-if="data.details"
            v-bar="{
                overrideFloatingScrollbar: true,
                observerThrottle: 0,
                draggingPhantomDelay: 0,
                scrollingPhantomDelay: 0,
                resizeRefresh: false
            }"
        >
            <v-list class="listreset">
                <v-subheader class="pa-0 pb-2 font-weight-bold black--text h3">
                    {{ $t('utils.globalInformation') }}
                </v-subheader>
                <v-list-item>
                    <v-card
                        v-if="prices"
                        rounded
                        elevation="0"
                        width="100%"
                        class="d-block mb-4 pa-4 price-section"
                    >
                        <span
                            v-if="prices.totalPrice"
                            class="global-nav font-weight-bold d-block"
                            v-html="prices.totalPrice.text + ' ' + prices.totalPrice.value"
                        />
                        <span
                            v-if="prices.totalPrice.value !== prices.lotPrice.value"
                            class="d-block habiteo-body-3"
                            v-html="prices.lotPrice.text + ' ' + prices.lotPrice.value"
                        />
                        <span
                            v-if="prices.totalPrice.value !== prices.lotPrice.value"
                            class="d-block habiteo-body-3"
                            v-html="prices.annexPrice.text + ' ' + prices.annexPrice.value"
                        />
                    </v-card>
                </v-list-item>
                <v-list-item
                    v-for="(item, ind) in globalInfo"
                    :key="'detail' + ind"
                    :class=" { 'plot-description': item.id === 'description'}"
                >
                    <span v-if="item.id != 'name'">
                        {{ item.label }}
                        <span
                            :style="{ 'color': item.color }"
                            v-html="getDescription(item)"
                        />
                    </span>
                </v-list-item>
                <v-list-item v-if="tags">
                    <div class="tag-list">
                        <div
                            class="tag"
                            v-for="(tag, tagName) in tags.tags"
                            :key="tag.id + tagName"
                            :style="{ 'background-color': tag.color }"
                        >
                            <label class="cursor">
                                {{ tagName }}
                            </label>
                        </div>
                    </div>
                </v-list-item>
            </v-list>
            <v-list
                v-if="metrics"
                class="pt-8"
            >
                <v-subheader class="pa-0 pb-2 font-weight-bold black--text h3">
                    {{ $t('utils.metricInformation') }}
                </v-subheader>
                <v-list-item
                    v-for="(metric, metricName) in metrics.metrics"
                    :key="metric.id + metricName"
                >
                    {{ metricName }} :<span class="pl-2" v-html="decodeHTMLfromString(metric)"/>
                </v-list-item>
            </v-list>
        </div>
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'PlotSidebar',
        props: [
            'data',
            'handler',
            'isStandalone'
        ],
        data() {
            return {
                share: false,
                link: null,
                copyBtn: false,
                textToCopy: null,
                clickedTracking: false,
                offlineWidgets: [
                    '2d-plan',
                    '3d-plan'
                ],
                hover: false,
                favorite: false,
                disabledAvailabilities: [
                    2,      // Unavailable
                    4,      // Reserved
                    5       // Sold
                ],
                plotFavList: [],
                shareDialog: false,
                skippedDetails: [
                    'metrics'
                ],
                pricesDetails: [
                    'totalPrice',
                    'lotPrice',
                    'annexPrice'
                ]
            }
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable',
                'isOfflineMode',
                'isOnline'
            ]),
            prices() {
                const priceList = this.data.details ? this.data.details.filter(detail => this.pricesDetails.includes(detail.id)) : [];
                var prices = null;
                if (priceList.length) {
                    prices = {};
                    priceList.forEach(price => {
                        prices[price.id] = {
                                'text': price.label,
                                'value': price.value
                            };
                    });
                }
                return prices;
            },
            globalInfo() {
                const globalInfo = this.data.details ? this.data.details.filter(detail => !this.skippedDetails.includes(detail.id) && !this.pricesDetails.includes(detail.id)) : [];
                return globalInfo.length ? globalInfo : null;
            },
            tags() {
                const tags = this.data.details ? this.data.details.find(detail => detail.id === 'tags') : null;
                return tags ? tags : null;
            },
            metrics() {
                const metrics = this.data.details ? this.data.details.find(detail => detail.id === 'metrics') : null;
                return metrics ? metrics : null;
            },
            currentLevel() {
                const level = this.data.details ? this.data.details.find(detail => detail.id === "level") : null;
                return level ? level : null;
            },
            programUuid() {
                return this.$props.data.program.id;
            },
            plotId() {
                return this.$props.data ? this.$props.data.plotId || (this.$props.data.type === 'plot' ? this.$route.query.id : null) : null;
            },
            favoriteKey() {
                return `favorite-${this.programUuid}`;
            },
            favoriteList: {
                get() {
                    return this.plotFavList;
                },
                set(newValue) {
                    localStorage.setItem(this.favoriteKey, JSON.stringify(newValue));
                    this.plotFavList = JSON.parse(localStorage.getItem(this.favoriteKey));
                }
            },
            isFavorite() {
                let status = false;
                if (this.isAvailabilityEnabled())
                    status = this.favoriteList.includes(this.plotId);
                return status;
            },
            widgetLink() {
                if (this.plotId)
                    return origin + "/lot?id=" + this.plotId + "&key=" + this.$route.query.key;
                else {
                    const idThreeD = this.$props.data.items.find(item => item.id = "3d-plan");
                    return origin + "/plan-3d?id=" + idThreeD.subid + "&key=" + this.$route.query.key;
                }
            }
        },
        mounted() {
            this.handler();
            this.refreshFavorites();
        },
        methods: {
            ...mapActions([
                'setSnackbar'
            ]),
            setActive(item, subitem) {
                switch (item.id) {
                    case 'configurable-tour':
                        EventBus.$emit('saveSidebar');
                        this.data.items.filter(el => el.active).forEach(el => { el.active = false });
                        this.$set(item, 'active', true);
                        EventBus.$emit('updateLoadedWidgets', {
                            id: 'configurable-tour',
                            link: item.link,
                            active: true,
                            widgetType: 'configurable-tour'
                        });
                    break;

                    case 'sunshine':
                        this.data.items.filter(el => el.active).forEach(el => { el.active = false });
                        this.$set(item, 'active', true);
                        EventBus.$emit('loadIframeWidget', item.id, item.url);
                    break;

                    case '3d-plan':
                        let activeWidget = this.data.items.filter(el => el.active)[0];
                        if (activeWidget.id === '3d-plan')
                            EventBus.$emit('3d_SetActive', item, subitem);
                        else
                            EventBus.$emit('plot_SetActive', item, subitem);
                    break;

                    default:
                        if (item.id === '2d-plan' && this.$vuetify.breakpoint.smAndDown)
                            EventBus.$emit('closeSidebar');
                        EventBus.$emit('plot_SetActive', item, subitem);
                    break;
                }
            },
            decodeHTMLfromString(str) {
                let decoder = document.createElement('textarea');
                decoder.innerHTML = str;
                return decoder.value;
            },
            toggleShare() {
                const origin = window.location.origin;
                const key = this.$route.query.key;

                this.share = !this.share;
                if (!this.share)
                    this.copyBtn = false;
                this.textToCopy = this.$t('share.copyLink');

                if (this.$props.data.plotId)
                    this.link = origin + "/lot?id=" + this.$props.data.plotId + "&key=" + key;
                else {
                    const idThreeD = this.$props.data.items.find(item => item.id = "3d-plan");
                    this.link = origin + "/plan-3d?id=" + idThreeD.subid + "&key=" + key;
                }
            },
            copyLink() {
                let range = document.createRange();
                range.selectNode(document.getElementById("urlToCopy"));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand("copy");
                window.getSelection().removeAllRanges();
                this.snackbarVisible = true;
                this.shareDialog = false;

                this.setSnackbar({
                    'message': this.$t('share.copy'),
                    'orientation': 'top'
                });
            },
            toggleCopy() {
                this.copyBtn = !this.copyBtn;
                if (this.share) {
                    if (this.copyBtn)
                        this.textToCopy = this.$t('share.copy');
                }
            },
            trackingEventHot() {
                let event = "hot";
                let data = this.data.items.filter(el => el.active)[0];
                if (data.id !== "sunshine" && !this.clickedTracking) {
                    this.clickedTracking = true;
                    let trackingData;
                    if (data.submenu) {
                        let submenu = data.submenu.filter(el => el.active)[0];
                        trackingData = submenu.tracking;
                        if (submenu.alternateModel)
                            trackingData.alternateModel = submenu.alternateModel;
                    } else
                        trackingData = data.tracking;

                    EventBus.$emit('trackingEvent', trackingData, event);
                    setTimeout(() => {
                        this.clickedTracking = false;
                    }, 10000);
                }
            },
            getGlobalInfo() {
                const globalInfo = this.data.details.filter(detail => detail.id !== 'metrics');
                this.globalInfo = globalInfo ? globalInfo : null;
            },
            getMetrics(){
                const metrics = this.data.details.find(detail => detail.id === 'metrics');
                this.metrics = metrics ? metrics : null;
            },
            refreshFavorites() {
                if (this.isLocalstorageAvailable)
                    this.plotFavList = localStorage.getItem(this.favoriteKey) ? JSON.parse(localStorage.getItem(this.favoriteKey)) : [];
            },
            isAvailabilityEnabled() {
                let availability = this.data.details.filter(detail => detail.id === "availability");
                return availability.length ? !this.disabledAvailabilities.includes(availability[0].type) : false;
            },
            toggleFavorite() {
                if (this.plotId) {
                    if (!this.favoriteList.includes(this.plotId)) {
                        var plotList = this.favoriteList ? this.favoriteList : [];
                        plotList.push(this.plotId);
                        this.favoriteList = plotList;
                        this.displayFavoriteBanner();
                    }
                    else {
                        var plotList = this.favoriteList.filter(favPlotId => {
                            return favPlotId !== this.plotId
                        });

                        this.favoriteList = plotList;
                    }
                }
            },
            displayFavoriteBanner() {
                let localStorageKey = 'favorite-banner-' + this.$route.query.id + '-' + this.$route.query.key;
                let nextDisplayDate = this.isLocalstorageAvailable ? localStorage.getItem(localStorageKey) : null;
                let today = new Date().getTime();
                if (!nextDisplayDate || nextDisplayDate <= today) {
                    // 30 days between each time the banner is displayed
                    let lifeCycle = 30 * 24 * 60 * 60 * 1000;
                    let nextDate = new Date(new Date().getTime() + lifeCycle);
                    if (this.isLocalstorageAvailable)
                        localStorage.setItem(localStorageKey, nextDate.getTime());
                    EventBus.$emit('displayFlashMessage', this.$t("flashMessage.favorite"));
                }
            },
            getDescription(item) {
                let vm = this;
                switch(item.id) {
                    case 'description':
                        return vm.decodeHTMLfromString(item.value);
                    case 'surface':
                    case 'surface_annex':
                        return item.unit ? item.value + ' ' + item.unit : item.value;
                    default:
                        return item.value;
                }
            }
        }
    };
</script>

<style lang="scss">
    @import "@/assets/scss/components/_share-favorite.scss";
    @import "@/assets/scss/components/_tags.scss";

    .share {
        margin-right: 50px;
        font-size: 13px;
    }

    .copy {
        cursor: pointer;
    }

    .link {
        text-transform: lowercase;
        display: flex !important;
        font-size: 12px;
    }

    .overflow-ellipsis {
        width: 230px;
        overflow: hidden;
        div {
            &.link {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }

    .v-sheet.v-card.price-section {
        background-color: #f3f3f3;
    }

    .plotDetailsTitle {
        text-decoration: underline;
        padding: 10px 0;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/layout/sidebar/PlotSidebar.vue